import { Component, OnInit } from '@angular/core';

import { LoginService } from 'src/app/user/services/login.service';
import { IUser } from 'src/app/user/models/user.model';
import { HttpParams, HttpResponse } from '@angular/common/http';
import { CompanyService } from 'src/app/user/services/company.service';
import { CompanyListItem } from 'src/app/user/models/company-list.model';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit {

  user: IUser;
  selectedCompany: number;
  loginCompanies: any = [];
  menuState = false;

  constructor(
    private loginService: LoginService,
    private companyService: CompanyService
  ) {
    const userData = localStorage.getItem('user');
    this.user = <IUser>JSON.parse(userData);
    this.selectedCompany = +localStorage.getItem('selectedCompany');
  }

  ngOnInit() {
    if (this.loginService.isSuperadmin()) {
      const httpParams = new HttpParams()
        .set('orderby', 'Name asc')
        .set('filter', 'IsActive == True');

      this.companyService.get(httpParams).subscribe((data: HttpResponse<CompanyListItem[]>) => {
        this.loginCompanies = data.body;
      });
    } else {
      this.loginCompanies = JSON.parse(localStorage.getItem('loginCompanies'));
    }
  }

  onLogout() {
    this.loginService.logout();
    location.reload(true);
  }

  onselectCompany(companyId) {
    localStorage.setItem('selectedCompany', companyId);
    this.selectedCompany = companyId;

    if (!this.loginService.isSuperadmin()) {
      const company = this.loginCompanies.filter(item => item.companyId === this.selectedCompany)[0];
      localStorage.setItem('permission', company.permissionType);
    }

    location.reload(true);
  }

  toogleMenu(value) {
    this.menuState = value;
  }

}
